export const categories = [
  {
    id: 1,
    name: 'Shoes',
    nameDe: 'Schuhe',
    icon: 'ri-footprint-line',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Sneaker, Laufschuhe & mehr entdecken',
  },
  {
    id: 2,
    name: 'Hoodies/Sweaters',
    nameDe: 'Hoodies & Pullover',
    icon: 'ri-t-shirt-line',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    description: 'Bequeme Streetwear für jeden Tag',
  },
  {
    id: 3,
    name: 'T-Shirts',
    nameDe: 'T-Shirts',
    icon: 'ri-shirt-line',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    description: 'Basic & Premium T-Shirts',
  },
  {
    id: 4,
    name: 'Jackets',
    nameDe: 'Jacken',
    icon: 'ri-gallery-line',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    description: 'Winterjacken, Windbreaker & mehr',
  },
  {
    id: 5,
    name: 'Pants/Shorts',
    nameDe: 'Hosen & Shorts',
    icon: 'ri-pantone-line',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    description: 'Jeans, Cargohosen, Shorts',
  },
  {
    id: 6,
    name: 'Headwear',
    nameDe: 'Kopfbedeckung',
    icon: 'ri-customer-service-2-line',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    description: 'Caps, Beanies & Hüte',
  },
  {
    id: 7,
    name: 'Sets',
    nameDe: 'Sets',
    icon: 'ri-stack-line',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    description: 'Komplette Outfit-Sets',
  },
  {
    id: 8,
    name: 'Underwear/Underpants',
    nameDe: 'Unterwäsche',
    icon: 'ri-user-heart-line',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    description: 'Bequeme Basics für jeden Tag',
  },
  {
    id: 9,
    name: 'Jersey',
    nameDe: 'Trikots',
    icon: 'ri-football-line',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    description: 'Fußball, Basketball & mehr',
  },
  {
    id: 10,
    name: 'Accessories',
    nameDe: 'Accessoires',
    icon: 'ri-bear-smile-line',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    description: 'Schmuck, Uhren, Sonnenbrillen',
  },
  {
    id: 11,
    name: 'Bags',
    nameDe: 'Taschen',
    icon: 'ri-briefcase-line',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    description: 'Rucksäcke, Umhängetaschen & mehr',
  },
  {
    id: 12,
    name: 'Belts',
    nameDe: 'Gürtel',
    icon: 'ri-link',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    description: 'Ledergürtel & modische Gürtel',
  },
  {
    id: 13,
    name: 'Perfumes',
    nameDe: 'Parfums',
    icon: 'ri-contrast-drop-line',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    description: 'Designer & Nischendüfte',
  },
  {
    id: 14,
    name: 'Other Stuff',
    nameDe: 'Sonstiges',
    icon: 'ri-more-line',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    description: 'Alles Weitere entdecken',
  },
];